import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import TitleBarToggle from "../../../components/layout/title_bar/TitleBarToggle";
import TitleBarSpacer from "../../../components/layout/title_bar/TitleBarSpacer";
import TitleBarTitle from "../../../components/layout/title_bar/TitleBarTitle";
import TitleBar from "../../../components/layout/title_bar/TitleBar";
import Panel from "../../../components/layout/panel/Panel";
import ExpertPage from "./ExpertPage";
import OwnerPage from "./OwnerPage";
import './certificate.scss';


const HomepageCertificates = () => {

    const location = useLocation();
    const navigate = useNavigate();

    // Redirect to the correct page based on the toggle state
    const onToggle = (e) => {
        if(e.target.checked){
            navigate("/certificates/expert/dashboard");
        } else {
            navigate("/certificates/owner/requests");
        }
    }


    return (
        <Panel id="certificate-panel" className="overflow-y-scroll">
            <TitleBar className="bg-dark my-2 p-2 ps-5 pe-3 rounded">
                <TitleBarSpacer width={5} />
                <TitleBarTitle>Certificates</TitleBarTitle>
                <TitleBarToggle
                    defaultValue={(location.pathname.split("/")[2] === "expert") ? true : false}
                    onToggle={onToggle}
                    preLabel="Owner"
                    label="Expert"
                />
            </TitleBar>

            <Routes>
                <Route path="/" element={<Navigate to="./owner/requests" />} />
                <Route path="owner/*" element={<OwnerPage activeTab={location.pathname.split("/")[3]} />} />
                <Route path="expert/*" element={<ExpertPage activeTab={location.pathname.split("/")[3]} />} />
            </Routes>
        </Panel>
    )
};

export default HomepageCertificates;